import React, { useState, useEffect } from 'react'
import transactionStore from './stores/transaction'
import destinationStore from '@/../stores/destination'
import Pagination from '@/../components/Pagination'
import { twMerge } from 'tailwind-merge'
import Table from '@/../components/Table'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used
import Button from '@/../components/Button'
import Modal from '@/../components/Modal'
import { Text, Radios } from '@/../components/Fields'
import CategorySelect from '@/../components/CategorySelect'
import DestinationSelect from '@/../components/DestinationSelect'
import RegionSelect from '@/../components/RegionSelect'
import { DateTime } from 'luxon'
import { produce } from 'immer'

export default function () {
  const [
    collection,
    setCollection,
    total,
    setTotal,
    page,
    setPage,
  ] = transactionStore(state => [
    state.collection,
    state.setCollection,
    state.total,
    state.setTotal,
    state.page,
    state.setPage,
  ])

  const [
    fetchDestinations,
  ] = destinationStore(state => [
    state.fetch,
  ])

  const fetchTransactions = async () => {
    const response = await fetch(`/api/inventory_transactions.json?page=${page}`)
    const data = await response.json()
    setCollection(data.collection)
    setTotal(data.total)
  }

  useEffect(() => {
    fetchTransactions()
  }, [page])

  useEffect(() => {
    fetchDestinations()
  }, [])

  return (
    <>
      <div className="flex justify-between gap-4 mb-4 items-end">
        <div className='flex gap-4'>
          <h1 className="text-4xl">Transactions</h1>
        </div>
        <Pagination {...{total, page, setPage}} />
      </div>
      <Table>
        <Table.Head>
          <Table.Row>
            <Table.Th>ID</Table.Th>
            <Table.Th>Location</Table.Th>
            <Table.Th>Date</Table.Th>
            <Table.Th>Direction</Table.Th>
            <Table.Th>Products</Table.Th>
            <Table.Th>Destinations</Table.Th>
            <Table.Th>Category</Table.Th>
            <Table.Th width="120">Product count</Table.Th>
            <Table.Th width="103"></Table.Th>
            <Table.Th width="131"></Table.Th>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {collection && collection.map(transaction => (
            <TransactionRow key={transaction.id} {...{transaction}} />
          ))}
        </Table.Body>
      </Table>
    </>
  )
}

const TransactionRow = ({ transaction }) => {

  const [editing, setEditing] = useState(false)
  const [removing, setRemoving] = useState(false)
  const [warning, setWarning] = useState(false)
  const [
    destinations,
  ] = destinationStore(state => [
    state.collection,
  ])
  const [
    transactionToEdit,
    setTransactionToEdit,
    deleteTransaction,
  ] = transactionStore(state => [
    state.transactionToEdit,
    state.setTransactionToEdit,
    state.delete,
  ])

  const faTrash = icon({ name: 'trash' })
  const pencil = icon({ name: 'pencil' })

  function edit(force = false) {
    setWarning(false)
    if (transactionToEdit.items_attributes?.length > 0 && !force) {
      return setWarning(true)
    }
    setTransactionToEdit(transaction)
  }

  async function remove(e) {
    e.preventDefault()
    await deleteTransaction(transaction)
    setRemoving(false)
  }

  return (
    <Table.Row className={transaction.direction > 0 ? 'bg-green-50' : 'bg-red-50'}>
      <Table.Td>{transaction.id}</Table.Td>
      <Table.Td>{transaction.location?.title}</Table.Td>
      <Table.Td>{DateTime.fromISO(transaction.created_at).toLocaleString(DateTime.DATE_MED)}</Table.Td>
      <Table.Td>{transaction.direction_label}</Table.Td>
      <Table.Td>
        <ul className="list-disc pl-6">
          {transaction.items_attributes && transaction.items_attributes.map((item) =>
            <li key={item.id}>{item.magento_id} - {item.quantity} - {item.title}</li>
          )}
        </ul>
      </Table.Td>
      <Table.Td>
        <ul className="list-disc pl-6">
          {transaction.destinations_transactions_attributes && transaction.destinations_transactions_attributes.map((item) => {
            const destination = destinations.find(d => d.id == item.destination_id)
            return <li key={item.id}><span className="font-bold">{destination?.financeCategory}</span>: {item.percentage}%</li>
          })}
        </ul>
      </Table.Td>
      <Table.Td>{transaction.category}</Table.Td>
      <Table.Td className="text-right">{transaction.items_attributes.reduce((acc, i) => acc + i.quantity, 0)}</Table.Td>
      <Table.Td>
        <Button onClick={() => edit()}>
          <FontAwesomeIcon icon={pencil} className="mr-2" />
          Edit
        </Button>
        <Modal isOpen={warning}>
          <Modal.Header>
            Warning
          </Modal.Header>
          <Modal.Body>
            <p>You have an open transaction. If you continue, the current transaction will be overwritten.</p>
          </Modal.Body>
          <Modal.Footer>
            <div className="flex items-center justify-between gap-4">
              <a href="#" onClick={() => {
                setWarning(false)
                setKitToShip(false)
                setQuantity(0)
              }}>
                Cancel
              </a>
              <Button type="danger" onClick={() => edit(true)}>
                <FontAwesomeIcon icon={icon({name: 'box'})} />
                Proceed
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </Table.Td>
      <Table.Td>
        <Button type="danger" onClick={() => setRemoving(true)}>
          <FontAwesomeIcon icon={faTrash} className="mr-2" />
          Remove
        </Button>
        <Modal isOpen={removing} onClose={() => setRemoving(false)}>
          <Modal.Header onClose={() => setRemoving(false)}>
            Are you sure?
          </Modal.Header>
          <Modal.Body>
            <p>
              Are you sure you want to remove transaction #{transaction.id}? This action cannot be undone.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className="flex items-center justify-between">
              <a href="#" onClick={() => setRemoving(false)}>
                Cancel
              </a>
              <Button type="danger" onClick={remove}>
                <FontAwesomeIcon icon={faTrash} className="mr-2" />
                Remove
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </Table.Td>
    </Table.Row>
  )
}
